//corresponding Enum on api side defined in ApplicationsManagementDB.cs
export const APPROVAL_WORKFLOW_TYPES = {
	SingleLevel: 'SingleLevel',
	MultiLevel: 'MultiLevel',
	None: 'None',
};
